import { render, staticRenderFns } from "./ListClinics.html?vue&type=template&id=56f61972&external"
import script from "./ListClinics.vue?vue&type=script&lang=js"
export * from "./ListClinics.vue?vue&type=script&lang=js"
import style0 from "./ListClinics.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports